import { HunterPartyDetail } from "Components/UserAccount/Hunter/HunterPartyDetail/HunterPartyDetail";
import { RelatedParties } from "Components/Users/UserDetailPageContent/Components/RelatedPartyForm/RelatedParties";
import {
  QueryParamTabs,
  type TabItem,
} from "Components/Shared/Tabs/QueryParamTabs";
import { getPublicInformationTab } from "Components/UserAccount/Shared/PublicInformationTab";
import type { AccountDetailProps as Props } from "Components/UserAccount/types";
import { UserSettingsSection } from "Components/UserAccount/Shared/UserSettings/UserSettingsSection";
import { VerificationForm } from "Components/UserAccount/Shared/VerificationForm/VerificationForm";
import { PrimaryPaper } from "Components/Shared/PrimaryPaper";
import { PartyType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Account;

export const HunterUserAccountDetail = ({ verification, party }: Props) => {
  const { t } = useResource();

  const isRelatedPartiesHidden = party.type !== PartyType.LegalEntity;
  const tabs: Array<TabItem> = [
    getPublicInformationTab(t, party),
    {
      id: "account",
      label: t(RESOURCES.AccountTab),
      content: (
        <PrimaryPaper>
          <UserSettingsSection />
        </PrimaryPaper>
      ),
    },
    {
      id: "party",
      label: t(RESOURCES.PersonalInformation),
      content: (
        <PrimaryPaper>
          <HunterPartyDetail party={party} />
        </PrimaryPaper>
      ),
    },
    {
      id: "verification",
      label: t(RESOURCES.Verification),
      content: (
        <PrimaryPaper>
          <VerificationForm
            verification={verification}
            partyType={party.type}
          />
        </PrimaryPaper>
      ),
    },
    {
      id: "relatedParties",
      label: t(RESOURCES.RelatedParties),
      content: (
        <PrimaryPaper>
          <RelatedParties
            relatedParties={party.relatedParties}
            owningPartyID={party.publicID}
          />
        </PrimaryPaper>
      ),
      isHidden: isRelatedPartiesHidden,
    },
  ];

  return <QueryParamTabs tabs={tabs} />;
};
